<template>
  <div class="acc-flow-index">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="100" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
      <auth-button auth="member:point:rule:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >积分清零</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #refId="{ row }">{{ row.refId }}</template>
      <template #amount="{ row }">{{ row.amount }}</template>
      <template #userId="{ row }">{{ row.userId }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #scene="{ row }">{{ row.scene }}</template>
      <template #orderNo="{ row }">{{ row.orderNo ? row.orderNo : '---' }}</template>
      <template #activityName="{ row }">{{ row.activityName ? row.activityName : '---' }}</template>
      <template #storeName="{ row }">{{ row.storeName ? row.storeName : '---' }}</template>
      <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName ? row.operatorName : '---' }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { downFile } from "@/utils";
import { api_getPointList, api_postPointListExport , api_batchResetPoint} from '@/api/integral'
import { api_getPointType, api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'

export default {
  name: "accFlowIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      tableKey: false,
      exportLoading: false,
      renderData: [
        {
          label: "积分ID",
          placeholder: "请输入积分ID",
          type: "input",
          key: "refId",
        },
        // {
        //   label: "会员ID",
        //   placeholder: "请输入会员ID",
        //   type: "input",
        //   key: "userId",
        // },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength: 11,
        },
        {
          label: "积分类型",
          placeholder: "请选择积分类型",
          type: "select",
          multiple: false,
          key: "scene",
          option: [],
        },
        {
          label: "更新时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "updateTime",
        },
      ],
      form: {
        refId: '',
        userId: '',
        phone: '',
        scene: ''
      },
      tableThData: [
        { prop: "refId", label: "积分ID", minWidth: "150", },
        { prop: "amount", label: "积分变动", minWidth: "100", },
        // { prop: "userId", label: "会员ID", minWidth: "100", },
        { prop: "phone", label: "会员手机号", minWidth: "150", },
        { prop: "scene", label: "积分类型", minWidth: "120", },
        { prop: "orderNo", label: "订单编号", minWidth: "180", },
        { prop: "activityName", label: "活动名称", minWidth: "180", },
        { prop: "storeName", label: "店铺名称", minWidth: "180", },
        { prop: "updated", label: "更新时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "120", },
      ],
      categoryData: [], // 积分类型数据
    };
  },
  created () {
    this.getPointType()
  },
  methods: {
    onAdd () {
      this.$baseConfirm(
          '是否确认将所有用户积分清零？',
          {
            title: '提示',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
          },
          async () => {
           //alert(params)
           // this.$route.query.userId ? await api_batchResetPoint({userIds: [this.$route.query.userId] }) : await api_batchResetPoint()
            await api_batchResetPoint()
            this.$baseMessage('操作成功', 'success')
            this.getList()
          }
        )
    },
    async getPointType () {
     const data =  await api_getPointType()
     console.log(data)
     this.renderData[2].option = data.map((item) => {
       return {
         label: item.desc,
         value: item.name,
       }
     })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params = {
        ...params,
        startTime: params.updateTime && params.updateTime[0] ? this.$moment(params.updateTime[0]).valueOf() : '',
        endTime: params.updateTime && params.updateTime[1] ? this.$moment(params.updateTime[1]).valueOf() : '',
      }
      params.startTime == ''? delete params.startTime:''
      params.endTime == ''? delete params.endTime:''
      params.refId == '' ? delete params.refId:''
      params.phone == '' ? delete params.phone:''
      params.scene == ''? delete params.scene:''
      params.userId == ''? delete params.userId:''
      delete params.updateTime
      try {
        const data = await api_getPointList(params)
        console.log('data: ', data);
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
      switch (this.form.scene) {
        case 'Order':
        case 'Examination':
        case 'WxMerchant':
        case 'RollBack':
        this.tableThData = [
          { prop: "refId", label: "积分ID", minWidth: "150", },
          { prop: "amount", label: "积分变动", minWidth: "100", },
          { prop: "phone", label: "会员手机号", minWidth: "150", },
          { prop: "scene", label: "积分类型", minWidth: "120", },
          { prop: "orderNo", label: "订单编号", minWidth: "180", },
          { prop: "storeName", label: "店铺名称", minWidth: "180", },
          { prop: "updated", label: "更新时间", minWidth: "180", },
          { prop: "operatorName", label: "操作人", minWidth: "120", }
          ]
          break;
        case 'Lottery':
        case 'Roulette':
        this.tableThData = [
          { prop: "refId", label: "积分ID", minWidth: "150", },
          { prop: "amount", label: "积分变动", minWidth: "100", },
          { prop: "phone", label: "会员手机号", minWidth: "150", },
          { prop: "scene", label: "积分类型", minWidth: "120", },
          { prop: "orderNo", label: "订单编号", minWidth: "180", },
          { prop: "activityName", label: "活动名称", minWidth: "180", },
          { prop: "updated", label: "更新时间", minWidth: "180", },
          { prop: "operatorName", label: "操作人", minWidth: "120", }
          ]
          break;
        default:
          this.tableThData= [
            { prop: "refId", label: "积分ID", minWidth: "150", },
            { prop: "amount", label: "积分变动", minWidth: "100", },
            { prop: "phone", label: "会员手机号", minWidth: "150", },
            { prop: "scene", label: "积分类型", minWidth: "120", },
            { prop: "orderNo", label: "订单编号", minWidth: "180", },
            { prop: "updated", label: "更新时间", minWidth: "180", },
            { prop: "operatorName", label: "操作人", minWidth: "120", },
          ]
          break;
      }
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      let params = {
        ...this.form,
      }
      params = {
        ...params,
        startTime: params.updateTime && params.updateTime[0] ? this.$moment(params.updateTime[0]).valueOf() : '',
        endTime: params.updateTime && params.updateTime[1] ? this.$moment(params.updateTime[1]).valueOf() : '',
      }
      params.startTime == ''? delete params.startTime:''
      params.endTime == ''? delete params.endTime:''
      params.refId == '' ? delete params.refId:''
      params.phone == '' ? delete params.phone:''
      params.scene == ''? delete params.scene:''
      params.userId == ''? delete params.userId:''
      delete params.updateTime
      let res = await api_postPointListExport(params)
      console.log(res)
      downFile(res)
      this.exportLoading = false
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.acc-flow-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .el-button {
    min-width: 80px !important;
  }
}
</style>
